import { useMemo } from "react";

import { translate } from "app/filters/i18nFilter";
import { SelectCombobox } from "app/pages/sales-intelligence/common-components/dropdown/SelectCombobox";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import type CompanyFilter from "app/pages/sales-intelligence/modules/leads-search-filters/models/CompanyFilter/CompanyFilter";
import type { IDropDownExtendedItem } from "app/pages/sales-intelligence/sub-modules/advanced-search/components/shared/ControlledMultiDropdown/ControlledMultiDropdown";
import trackingService from "app/pages/sales-intelligence/sub-modules/advanced-search/services/tracking/advancedSearchTrackingService";

import { COUNTRY_SELECT_WIDTH } from "../../../constants";
import { StyledCountryDropdownContainer } from "../styles";

import { CompanyDDItem } from "./CompanyDDItem";
import { mapCompanyDomainsToOptions } from "./utils";

const CompanySelectFilter = ({ value, onFilterUpdate, filter: { options } }: IFilterViewBaseProps<CompanyFilter>) => {
    const items = useMemo(() => mapCompanyDomainsToOptions(options), [options]);
    const selectedIdSet = useMemo(() => new Set(value ?? []), [value]);

    const handleSelect = (selectedItem: IDropDownExtendedItem) => {
        const selectedId = String(selectedItem.id);

        if (value?.includes(selectedId)) {
            onFilterUpdate(value?.filter((item) => item !== selectedId) ?? []);
            return;
        }

        onFilterUpdate([...(value ?? []), selectedId]);
        trackingService.trackCompanySelectFilterChange(selectedItem.text ?? selectedId);
    };

    return (
        <StyledCountryDropdownContainer
            customWidth={COUNTRY_SELECT_WIDTH}
            data-automation="company-filter-dropdown"
        >
            <SelectCombobox<IDropDownExtendedItem>
                items={items}
                isItemSelected={(item) => selectedIdSet.has(String(item.id))}
                onSelect={handleSelect}
                hasSearch
                searchPlaceHolder={translate("si.lead_gen_filters.group.includeDomains.dd.search.placeholder")}
                buttonText={translate("si.lead_gen_filters.group.includeDomains.dd.placeholder")}
                renderOption={(item, isSelected) => (
                    <CompanyDDItem
                        item={item}
                        selected={isSelected}
                    />
                )}
            />
        </StyledCountryDropdownContainer>
    );
};

export default CompanySelectFilter;
